import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Globals } from '../../globals';

@Injectable()
export class SalesServices {
    private firestore: any;

    constructor(public afs: AngularFirestore,
        public globals: Globals) {
        this.firestore = firebase.firestore();
    }

    //get payed tickets
    async getLast7TicketsPayedList(UID_RESTAURANT) {
        const ticketsRef = this.firestore.collection('tickets');
        var tickets = [];

        await ticketsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('payment', '==', true)
            .orderBy('date', 'desc')
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var ticket = doc.data();
                    ticket.UID = doc.id;
                    ticket.date_show = this.globals.timestampToDate(ticket.date);
                    tickets.push(ticket);
                });
            });

        return tickets.slice(0, 7);

    }

    //get customers
    async get7Customers(UID_RESTAURANT) {
        const customersRef = this.firestore.collection('customers');

        var customers = [];

        await customersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var customer = doc.data();
                    customer.UID = doc.id;

                    customers.push(customer);
                });
            });

        return customers.slice(0, 7);
    }

    //get close cash
    async getLast7CloseCashList(UID_RESTAURANT) {
        const historialRef = this.firestore.collection('historial');
        var historial = [];

        await historialRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .orderBy('date', 'desc')
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var closecash = doc.data();
                    closecash.UID = doc.id;

                    historial.push(closecash);
                });
            });

        return historial.slice(0, 7);

    }

    //get providers
    async get7Providers(UID_RESTAURANT) {
        const providersRef = this.firestore.collection('providers');

        var providers = [];

        await providersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var provider = doc.data();
                    provider.UID = doc.id;

                    providers.push(provider);
                });
            });

        return providers.slice(0, 7);
    }

    //get close cash
    async getLast7InvoicesList(UID_RESTAURANT) {
        const historialRef = this.firestore.collection('invoices');
        var historial = [];

        await historialRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('invoice_confirm', '==', true)
            .orderBy('created_at', 'desc')
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var closecash = doc.data();
                    closecash.UID = doc.id;

                    historial.push(closecash);
                });
            });

        return historial.slice(0, 7);

    }


}



// WEBPACK FOOTER //
// ./src/pages/sales/services.ts